// test2506
(2506 && 0);
